import { useCurrentUser } from "./useCurrentUser"

export const useHasSuperAdminPrivilege = () => {
  const currentUser = useCurrentUser()
  return currentUser.superAdmin
}
